<script>
import { TravelOrderStatusMap } from "@/data/trip";

export default {
  name: "TravelOrderStatusLabel",
  props: {
    travelOrder: Object,
  },
  computed: {
    status() {
      return TravelOrderStatusMap.find((s) => s.id === this.travelOrder.status)?.name;
    },
    classes() {
      return TravelOrderStatusMap.find((s) => s.id === this.travelOrder.status)?.forCancellation
        ? "text-white bg-red-lighten-2"
        : "text-grey-darken-1";
    },
  },
};
</script>

<template>
  <v-chip :class="classes" density="comfortable" rounded size="small" v-bind="$props">
    {{ status }}
  </v-chip>
</template>
